// ============================================================
// What the log says when Undying refuses a death (engine/postHitEffects
// writes it; engine/structuredNarrative reads it back as the status's
// cheatedDeath, which the map plays as its fall and rise). Its own module
// so the narrative never imports the hit engine for one string.
// ============================================================

export const UNDYING_REASON = '♾ Undying - cannot die by normal means';

/** Its refusal of Dying, in words of its own: not a death cheated, so the map plays no fall. */
export const UNDYING_DYING_REASON = '♾ Undying - it does not begin to die';
